export enum CruiseDetailsVariant {
	Basic = 'basic',
	Refined = 'refined',
}

export enum CruiseDetailsAction {
	Expand = 'expand',
	Collapse = 'collapse',
}

export interface CruiseDetailsProps {
	variant: CruiseDetailsVariant;
}
